/* SwitchToIotOsPlanExplorerComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const SwitchToIotOsPlanExplorerRenderer = require("./SwitchToIotOsPlanExplorerRenderer");

/**
 * This is a hack view component to switch view to Device Explorer
 */
class SwitchToIotOsPlanExplorerComponent extends EventEmitter {
    constructor(logger, gameEditor, steveIo, EditorSectionMgr) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._fileFactory = steveIo.fileFactory;
        this._editorComponent = EditorSectionMgr;
        this._renderer = new SwitchToIotOsPlanExplorerRenderer(this);
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    closeAllEditors() {
        this._editorComponent._editorLayout.closeAllEditors();
    }

    shutdown() {
        return this._renderer.shutdown().then(() => {
            this._logger = undefined;
            this._fileFactory = undefined;
            this._editorComponent = undefined;
            this._gameEditor = undefined;
            this._renderer = undefined;
            return Promise.resolve();
        });
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }
}
module.exports = SwitchToIotOsPlanExplorerComponent;

SwitchToIotOsPlanExplorerComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.io",
    "EditorSection.EditorSectionMgr",
];

SwitchToIotOsPlanExplorerComponent.$displayDetails = {
    type: "View",
    name: "IoT Device Explorer",
    icon: "osmanager.iot_os_plan",
    title: "IoT OS Plan Explorer",
    shown: true,
    order: 4,
};
